import React from 'react';
import UserMenuItems from './UserMenuItems';

interface UserProfileContentProps {
  isLogin: boolean;
  userMetaData: {
    name?: string;
  };
  theme: any;
  t: (key: string) => string;
  isMobile: boolean;
  onLiveSupport: () => void;
  onLogout: () => void;
  onClose: () => void;
}

const UserProfileContent: React.FC<UserProfileContentProps> = ({
  isLogin,
  userMetaData,
  theme,
  t,
  isMobile,
  onLiveSupport,
  onLogout,
  onClose,
}) => {
  return (
    <div
      onClick={onClose}
      className={`
        ${isMobile ? 'w-full mt-0' : 'w-[210px] mt-2'}
        pb-2
        font-medium
        ${isMobile ? 'rounded-none' : 'rounded-lg border border-white/15'}
        [&_*]:font-inherit
        [&_*]:text-inherit
      `}
      style={{
        backgroundColor: '#16161B',
      }}
    >
      <UserMenuItems
        isMobile={isMobile}
        isLogin={isLogin}
        userMetaData={userMetaData}
        theme={theme}
        t={t}
        onLiveSupport={onLiveSupport}
        onLogout={onLogout}
        onClose={onClose}
      />
    </div>
  );
};

export default UserProfileContent;
